(function () {
  'use strict';

  window.VI = window.VI || {};

  function normalizeText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizeType(value) {
    var text = normalizeText(value);
    var tokens = text.replace(/[^a-zåäö0-9]+/gi, ' ').trim().split(/\s+/).filter(Boolean);

    if (tokens.some(function (token) { return token === 'röd' || token === 'rött' || token.indexOf('röd') === 0 || token.indexOf('rött') === 0; })) return 'rött';
    if (tokens.some(function (token) { return token === 'vit' || token === 'vitt'; })) return 'vitt';
    if (tokens.some(function (token) { return token.indexOf('ros') === 0; })) return 'rosé';
    if (tokens.some(function (token) { return token.indexOf('mousser') === 0; })) return 'mousserande';
    if (tokens.some(function (token) { return token.indexOf('orange') === 0; })) return 'orange';
    if (tokens.some(function (token) { return token.indexOf('söt') === 0; })) return 'sött';
    return text;
  }

  function setCountText(element, count) {
    if (!element) return;
    element.textContent = count === 1 ? '1 vin' : count + ' viner';
  }

  function initProductCatalog(root) {
    if (!root || (root.dataset.viCatalogInitialized === 'true' && typeof root.__viOpenProductCatalog === 'function')) return;
    root.dataset.viCatalogInitialized = 'true';

    var overlay = root.querySelector('[data-catalog-overlay]');
    var dialog = root.querySelector('.vimport-b2b-product-catalog__dialog');
    var rootOpenButton = root.querySelector('[data-catalog-open]');
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-close]'));
    var searchInput = root.querySelector('[data-catalog-search]');
    var typeSelect = root.querySelector('[data-catalog-type]');
    var producerButtons = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-producer]'));
    var producerOptionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-producer-option]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-card]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-producer-group]'));
    var resultCount = root.querySelector('[data-catalog-result-count]');
    var totalCount = root.querySelector('[data-catalog-total-count]');
    var emptyState = root.querySelector('[data-catalog-empty]');
    var detailPanel = root.querySelector('[data-catalog-detail-panel]');
    var detailBody = root.querySelector('[data-catalog-detail-body]');
    var detailClose = root.querySelector('[data-catalog-detail-close]');
    var groupsScroller = root.querySelector('[data-catalog-groups]');
    var printButtons = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-print]'));

    if (!overlay || !dialog) return;

    var activeProducer = '';
    var activeDetailCard = null;
    var lastFocus = null;

    function updateProducerCounts(counts, total) {
      counts = counts || new Map();
      producerOptionButtons.forEach(function (button) {
        var key = button.getAttribute('data-catalog-producer') || '';
        var countNode = button.querySelector('[data-catalog-producer-count]');
        setCountText(countNode, counts.get(key) || 0);
      });

      setCountText(totalCount, total || 0);
    }

    function updateGroupCounts(counts) {
      counts = counts || new Map();
      groups.forEach(function (group) {
        var key = group.getAttribute('data-catalog-producer-group') || '';
        var count = counts.get(key) || 0;
        var countNode = group.querySelector('[data-catalog-group-count]');
        setCountText(countNode, count);
        group.hidden = count === 0;
      });
    }

    function setActiveProducerUi() {
      producerButtons.forEach(function (button) {
        var key = button.getAttribute('data-catalog-producer') || '';
        button.setAttribute('aria-current', key === activeProducer ? 'true' : 'false');
      });
    }

    function scrollToProducerGroup(producerKey) {
      if (!groupsScroller) return;

      window.requestAnimationFrame(function () {
        if (!producerKey) {
          if (typeof groupsScroller.scrollTo === 'function') {
            groupsScroller.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            groupsScroller.scrollTop = 0;
          }
          return;
        }

        var targetGroup = groups.find(function (group) {
          return group.getAttribute('data-catalog-producer-group') === producerKey;
        });

        if (targetGroup && !targetGroup.hidden && typeof targetGroup.scrollIntoView === 'function') {
          targetGroup.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      });
    }

    function closeDetail(options) {
      options = options || {};
      if (!detailPanel || !detailBody) return;

      var restoreFocus = options.restoreFocus !== false;
      var cardToRestore = activeDetailCard;

      detailPanel.hidden = true;
      detailBody.innerHTML = '';
      root.classList.remove('has-detail-open');

      if (activeDetailCard) {
        activeDetailCard.classList.remove('is-detail-active');
      }

      activeDetailCard = null;

      if (restoreFocus && cardToRestore && !cardToRestore.hidden) {
        var opener = cardToRestore.matches('[data-catalog-detail-open]') ? cardToRestore : cardToRestore.querySelector('[data-catalog-detail-open]');
        if (opener && typeof opener.focus === 'function') opener.focus();
      }
    }

    function openDetail(card, options) {
      options = options || {};
      if (!card || !detailPanel || !detailBody) return;

      var source = card.querySelector('[data-catalog-detail]');
      if (!source) return;

      if (activeDetailCard) {
        activeDetailCard.classList.remove('is-detail-active');
      }

      activeDetailCard = card;
      activeDetailCard.classList.add('is-detail-active');
      detailBody.innerHTML = source.innerHTML;
      detailPanel.hidden = false;
      root.classList.add('has-detail-open');

      if (options.focus !== false) {
        var focusTarget = detailPanel.querySelector('[data-catalog-detail-close]') || detailPanel;
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }
    }

    function applyFilters() {
      var query = searchInput ? normalizeText(searchInput.value) : '';
      var selectedType = typeSelect ? normalizeType(typeSelect.value) : '';
      var producerCounts = new Map();
      var groupCounts = new Map();
      var producerScopedTotal = 0;
      var visibleCards = 0;

      cards.forEach(function (card) {
        var textBlob = [
          card.getAttribute('data-title'),
          card.getAttribute('data-producer-name'),
          card.getAttribute('data-location'),
          card.getAttribute('data-country'),
          card.getAttribute('data-region'),
          card.getAttribute('data-grapes'),
          card.getAttribute('data-type'),
          card.getAttribute('data-product-text'),
          card.getAttribute('data-facts')
        ].join(' ').toLowerCase();

        var cardType = normalizeType(card.getAttribute('data-type'));
        var cardProducer = card.getAttribute('data-producer') || '';

        var matchesProducer = !activeProducer || cardProducer === activeProducer;
        var matchesSearch = !query || textBlob.indexOf(query) > -1;
        var matchesType = !selectedType || cardType === selectedType || cardType.indexOf(selectedType) > -1;
        var matchesCatalogTools = matchesSearch && matchesType;

        if (matchesCatalogTools && cardProducer) {
          producerScopedTotal += 1;
          producerCounts.set(cardProducer, (producerCounts.get(cardProducer) || 0) + 1);
        }

        var shouldShow = matchesProducer && matchesCatalogTools;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCards += 1;
          if (cardProducer) groupCounts.set(cardProducer, (groupCounts.get(cardProducer) || 0) + 1);
        }
      });

      if (groups.length) {
        updateGroupCounts(groupCounts);
      }

      if (activeDetailCard && activeDetailCard.hidden) {
        closeDetail({ restoreFocus: false });
      }

      setCountText(resultCount, visibleCards);
      if (emptyState) emptyState.hidden = visibleCards !== 0;
      if (groupsScroller) groupsScroller.hidden = visibleCards === 0;
      updateProducerCounts(producerCounts, producerScopedTotal);
    }

    function setActiveProducer(nextProducer, options) {
      options = options || {};
      activeProducer = nextProducer || '';
      setActiveProducerUi();
      applyFilters();
      if (options.scroll !== false) scrollToProducerGroup(activeProducer);
    }

    function resetCatalogTools() {
      if (searchInput) searchInput.value = '';
      if (typeSelect) typeSelect.value = '';
      closeDetail({ restoreFocus: false });
      setActiveProducer('');
    }

    function openCatalog(trigger) {
      var searchValue = trigger && trigger.dataset ? trigger.dataset.catalogSearchValue || '' : '';

      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.body.classList.add('vimport-b2b-product-catalog-is-open');

      if (searchValue) {
        activeProducer = '';
        if (typeSelect) typeSelect.value = '';
        if (searchInput) searchInput.value = searchValue;
        setActiveProducerUi();
      }
      applyFilters();

      window.requestAnimationFrame(function () {
        if (typeof dialog.focus === 'function') dialog.focus();
      });
    }

    function closeCatalog() {
      closeDetail({ restoreFocus: false });
      overlay.hidden = true;
      document.body.classList.remove('vimport-b2b-product-catalog-is-open');

      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    root.__viOpenProductCatalog = openCatalog;
    root.__viCloseProductCatalog = closeCatalog;

    function printCatalog() {
      if (typeof window.print !== 'function') return;
      var cleaned = false;
      var hiddenStates = [];
      var removePrintMediaListener = function () {};

      function forceVisibleForPrint(element) {
        if (!element) return;
        hiddenStates.push({ element: element, hidden: element.hidden });
        element.hidden = false;
      }

      function onPrintMediaChange(event) {
        if (!event.matches) cleanup();
      }

      var cleanup = function () {
        if (cleaned) return;
        cleaned = true;
        hiddenStates.forEach(function (state) {
          state.element.hidden = state.hidden;
        });
        root.classList.remove('is-printing');
        document.body.classList.remove('vimport-b2b-product-catalog-is-printing');
        window.removeEventListener('afterprint', cleanup);
        window.removeEventListener('pagehide', cleanup);
        removePrintMediaListener();
      };

      if (typeof window.matchMedia === 'function') {
        var printMedia = window.matchMedia('print');
        if (printMedia && typeof printMedia.addEventListener === 'function') {
          printMedia.addEventListener('change', onPrintMediaChange);
          removePrintMediaListener = function () { printMedia.removeEventListener('change', onPrintMediaChange); };
        } else if (printMedia && typeof printMedia.addListener === 'function') {
          printMedia.addListener(onPrintMediaChange);
          removePrintMediaListener = function () { printMedia.removeListener(onPrintMediaChange); };
        }
      }

      groups.forEach(forceVisibleForPrint);
      cards.forEach(forceVisibleForPrint);
      forceVisibleForPrint(groupsScroller);

      root.classList.add('is-printing');
      document.body.classList.add('vimport-b2b-product-catalog-is-printing');
      window.addEventListener('afterprint', cleanup);
      window.addEventListener('pagehide', cleanup);

      window.requestAnimationFrame(function () {
        try {
          window.print();
        } catch (error) {
          cleanup();
        }
      });
    }
    function dedupeProducerButtons() {
      var seen = new Set();

      producerOptionButtons.forEach(function (button) {
        var key = button.getAttribute('data-catalog-producer') || '';
        if (!key || seen.has(key)) {
          button.remove();
          return;
        }
        seen.add(key);
      });
    }

    dedupeProducerButtons();
    producerButtons = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-producer]'));
    producerOptionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-producer-option]'));

    setActiveProducerUi();
    applyFilters();

    if (rootOpenButton) {
      rootOpenButton.addEventListener('click', function (event) {
        event.preventDefault();
        openCatalog(rootOpenButton);
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeCatalog);
    });

    printButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        printCatalog();
      });
    });

    root.addEventListener('click', function (event) {
      var detailTrigger = event.target.closest('[data-catalog-detail-open]');
      if (detailTrigger && root.contains(detailTrigger)) {
        event.preventDefault();
        openDetail(detailTrigger.closest('[data-catalog-card]'));
        return;
      }

      var producerButton = event.target.closest('[data-catalog-producer]');
      if (producerButton && root.contains(producerButton)) {
        event.preventDefault();
        setActiveProducer(producerButton.getAttribute('data-catalog-producer') || '');
        return;
      }

      var resetButton = event.target.closest('[data-catalog-reset]');
      if (resetButton && root.contains(resetButton)) {
        event.preventDefault();
        resetCatalogTools();
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      var detailTrigger = event.target.closest('[data-catalog-detail-open]');
      if (!detailTrigger || !root.contains(detailTrigger)) return;

      event.preventDefault();
      openDetail(detailTrigger.closest('[data-catalog-card]'));
    });

    if (searchInput) searchInput.addEventListener('input', applyFilters);
    if (typeSelect) typeSelect.addEventListener('change', applyFilters);

    if (detailClose) {
      detailClose.addEventListener('click', function () {
        closeDetail();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (overlay.hidden) return;

      if (event.key === 'Tab') {
        var focusables = Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
        if (!focusables.length) return;

        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
        return;
      }

      if (event.key !== 'Escape') return;

      if (detailPanel && !detailPanel.hidden) {
        closeDetail();
        return;
      }

      closeCatalog();
    });

  }

  function initAll(scope) {
    var targetScope = scope || document;
    if (targetScope.matches && targetScope.matches('[data-vimport-product-catalog]')) {
      initProductCatalog(targetScope);
    }
    Array.prototype.slice.call(targetScope.querySelectorAll('[data-vimport-product-catalog]')).forEach(initProductCatalog);
  }

  window.VI.initProductCatalog = initProductCatalog;

  if (!window.VImportProductCatalogDelegated) {
    window.VImportProductCatalogDelegated = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-catalog-open-for]');
      if (!trigger) return;

      var targetId = trigger.getAttribute('data-catalog-open-for');
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target || typeof target.__viOpenProductCatalog !== 'function') return;

      event.preventDefault();
      target.__viOpenProductCatalog(trigger);
    });

    document.addEventListener('shopify:section:unload', function () {
      document.body.classList.remove('vimport-b2b-product-catalog-is-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
